interface CitationProps {
    n: number;
}

// Superscript link from a stat figure to its entry in ReferencesBlock.
// Build notes (content/unimo-industry-page-copy.md, "Citations"): real anchor
// (not a styled span), aria-label since the bare number means nothing to a
// screen reader, and a 24px tap target even though the glyph itself is small.
export function Citation({ n }: CitationProps) {
    return (
        <sup className="ml-1 align-top text-xs font-medium leading-none text-unimo-site-grey-500">
            <a href={`#ref-${n}`} id={`cite-${n}`} aria-label={`Reference ${n}`} className="-m-3 inline-block p-3">
                {n}
            </a>
        </sup>
    )
}

export default Citation
